import React, { useEffect, useRef, useState } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';
import "../../css/main.css"
import { PageMenuElement } from '../elements/page_menu.js';
import { Navigate, useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print'

export function ViewMembershipCardForm() {
  
  const [memberData, setMemberData] = useState([]);
  const [competencyData, setCompetencyData] = useState([]);
  const [pageData, setPageData] = useState();
  const [membershipStatus, setMembershipStatus] = useState([]);
  const [imageData, setImageData] = useState();
  const [supplimentaryData, setSupplimentaryData] = useState([]);
  const navigate = useNavigate();
  const componentRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  let first_render = useRef(true);

  const { MakeCall } = useAPICall();



  useEffect(() => {

    if (first_render.current === true) {
      LoadMemberDataForView();
      first_render.current = false;
    }

  },[handlePrint]);

  function MemberStatus() {
    let status = membershipStatus.find((element) => memberData.idpeveril_status === element.id);
    if (status) {
      return status.description;
    }
    return 'NONE';

  }

  const handleMemberDataFetchForView = (data) => {
    setPageData(data);
    setMemberData(data.components['member']);
    setCompetencyData(data.components['competencytypes']);
    setMembershipStatus(data.components['membershipstatuses']);
    setSupplimentaryData(data.components["supplimentarydata"]);
    LoadMemberImage(data.components['member'].idpeveril_member);
  }

  function LoadMemberDataForView() {

    MakeCall('member/getviewmemberpage', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleMemberDataFetchForView, false);
  }

  function ShowCompetencies() {
    let result = [];
    for (let i = 0; i < competencyData.length; i++) {
      const competency_item = competencyData[i];
      if (memberData.competencies.find((competency) => { if (competency.idpeveril_competency_type === competency_item.id) { return competency } return '' })) {
        result.push(<div className='formrow' key={competency_item.id} >
          <div className='formlabel'>{competency_item.description}</div>
          <div className='formvalue'>Y</div>
        </div>);
      }
      else {
        result.push(<div className='formrow' key={competency_item.id}>
          <div className='formlabel'>{competency_item.description}</div>
          <div className='formvalue'>N</div>
        </div>);
      }
    }
    return result;

  }
  function handleImageDataFetch(data) {
    setImageData(data.components['image_data']);
  }

  function LoadMemberImage(memberID) {
    const postBody = "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", " +
      "\"memberid\" : \"" + memberID + "\"}";

    MakeCall('admin/adminloadimage', postBody, handleImageDataFetch, true);
  }
  function ShowMemberImage() {
    let results = [];
    if (imageData) {
      results.push(<div><img alt='member' className='prcmemberimagesmall' src={'data:image/jpeg;base64,' + imageData} key="memberimg"></img></div>)
    }
    return results;
  }





  function onPageMenuClick(onclickname) {
    switch (onclickname) {
        case 'goback':
            navigate(-1);
            break;
        case 'print':
            handlePrint();
        break;
        default:
          break;
  
    }
  }

  

 
  return (

    <div>

      {SecurityElement(pageData)}
      {MenuForm()}
      

      <div className="contentdiv" >
      
      {PageMenuElement("Membership Card", [{ "name": "Back", "onclick": "goback" },
        {"name" : "Print", "onclick" : "print"}], onPageMenuClick, true)}
           <button onClick={handlePrint}>Print this out!</button>
            <div className='formbox' ref={componentRef}>
            
            <div className='formtitle'>Details</div>
            <div className='colspan'>
            <div style={{"width":"80%"}}>
              <div className='formrow'>
                <div className='formlabel' >Status</div>
                <div className='formvalue'>{MemberStatus()}</div>
              </div>
              <div className='formrow'>
                <div className='formlabel'>Number</div>
                <div className='formvalue'>{memberData.membership_number}</div>
              </div>
              <div className='formrow'>
                <div className='formlabel'>Type</div>
                <div className='formvalue'>{memberData.peveril_membership_type}</div>
              </div>
              <div className='formrow'>
                <div className='formlabel'>Forename</div>
                <div className='formvalue'>{memberData.forename}</div>
              </div>
              <div className='formrow'>
                <div className='formlabel'>Surname</div>
                <div className='formvalue'>{memberData.surname}</div>
              </div>
            </div>
            <div style={{"display": "flex", "width": "20%"}}>
              <div style={{"display": "flex","width": "100%", "alignContent": "right", "justifyContent":"end"}} >{ShowMemberImage()}</div>
            </div>
            </div>
          </div>
          
          <div className='formbox'>
            <div className='formtitle'>
              Competencies
            </div>
            {ShowCompetencies()}
          </div>
          </div>

      </div>
    


  );
}
